import { Reducer } from 'redux';
import { AppointmentsDetailReportState, AppointmentDetailReportStatus } from './AppointmentsDetailReportState';
import {
    APPOINTMENT_DETAIL_REPORT_GET_ERROR,
    APPOINTMENT_DETAIL_REPORT_GET_START,
    APPOINTMENT_DETAIL_REPORT_GET_SUCCESS,
    AppointmentsDetailReportAction
} from 'actions/insights/bookings/appointmentsDetail/AppointmentsDetailReportActionsTypes';

const initialState: AppointmentsDetailReportState = {
    items: [],
    status: AppointmentDetailReportStatus.Initial,
    loading: false
};

export const AppointmentsDetailReportReducer: Reducer<AppointmentsDetailReportState, AppointmentsDetailReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case APPOINTMENT_DETAIL_REPORT_GET_START:
            return {
                ...state,
                status: AppointmentDetailReportStatus.Getting,
                loading: true
            };
        case APPOINTMENT_DETAIL_REPORT_GET_SUCCESS:
            return {
                ...state,
                items: action.payload.items,
                page: action.payload.page,
                size: action.payload.size,
                totalPages: action.payload.totalPages,
                totalRecords: action.payload.totalRecords,
                status: AppointmentDetailReportStatus.GettingSuccess,
                loading: false
            };
        case APPOINTMENT_DETAIL_REPORT_GET_ERROR:
            return {
                ...state,
                status: AppointmentDetailReportStatus.Error,
                loading: false
            };
        default:
            return state;
    }
};
